import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Container,
    Box,
    Typography,
    Button,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import {
    Home as HomeIcon,
    DesignServices,
    Apps,
    Business,
    Assignment,
    Info,
    ContactMail,
    LightMode,
    DarkMode,
    Menu as MenuIcon,
    ChevronRight
} from '@mui/icons-material';
import { getTheme } from '../../theme/theme';

import darkLogo from '../../assets/logo/logo_dark.png';
import lightLogo from '../../assets/logo/logo_light.png';
const Header = ({ mode, toggleTheme }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    // Navigation items
    const navItems = [
        { id: 'home', label: 'Home', path: '/', icon: <HomeIcon /> },
        { id: 'services', label: 'Services', path: '/services', icon: <DesignServices /> },
        { id: 'solutions', label: 'Solutions', path: '/solutions', icon: <Apps /> },
        // { id: 'industries', label: 'Industries', path: '/industries', icon: <Business /> },
        // { id: 'case-studies', label: 'Case Studies', path: '/case-studies', icon: <Assignment /> },
        { id: 'about', label: 'About Us', path: '/about', icon: <Info /> },
        { id: 'contact', label: 'Contact', path: '/contact', icon: <ContactMail /> },
    ];

    // Dark Theme Logo component
    // const SoranovaDarkLogo = () => (
    //     <svg width="320" height="100" viewBox="0 0 380 60" xmlns="http://www.w3.org/2000/svg">
    //       <circle cx="30" cy="30" r="30" fill="#2D3142" stroke="#00E5FF" strokeWidth="2"/>
          
    //       <path d="M30 15 L40 25 L50 20 L60 35" stroke="#FF5678" strokeWidth="1.5" fill="none"/>
    //       <path d="M50 20 L40 35 L30 40 L15 30" stroke="#8A4FFF" strokeWidth="1.5" fill="none"/>
    //       <path d="M15 30 L25 40 L30 40" stroke="#4CAF50" strokeWidth="1.5" fill="none"/>
    //       <path d="M30 15 L20 25 L15 30" stroke="#FFD600" strokeWidth="1.5" fill="none"/>
          
    //       <circle cx="30" cy="15" r="3" fill="#FF5678"/>
    //       <circle cx="40" cy="25" r="3" fill="#FF5678"/>
    //       <circle cx="50" cy="20" r="3" fill="#FF5678"/>
    //       <circle cx="60" cy="35" r="3" fill="#FF5678"/>
    //       <circle cx="40" cy="35" r="3" fill="#8A4FFF"/>
    //       <circle cx="30" cy="40" r="3" fill="#8A4FFF"/>
    //       <circle cx="15" cy="30" r="3" fill="#8A4FFF"/>
    //       <circle cx="25" cy="40" r="3" fill="#4CAF50"/>
    //       <circle cx="20" cy="25" r="3" fill="#FFD600"/>
          
    //       <text x="70" y="30" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="#FFFFFF">SORANOVA</text>
    //       <text x="70" y="45" fontFamily="Arial, sans-serif" fontSize="10" fill="#00E5FF">TECHNOLOGIES</text>
    //     </svg>
    //   );
      
    //   // Light Theme Logo component
    //   const SoranovaLightLogo = () => (
    //     <svg width="320" height="100" viewBox="0 0 380 60" xmlns="http://www.w3.org/2000/svg">
    //       <circle cx="30" cy="30" r="30" fill="#F1F3F6" stroke="#2366E3" strokeWidth="2"/>
          
    //       <path d="M30 15 L40 25 L50 20 L60 35" stroke="#E91E63" strokeWidth="1.5" fill="none"/>
    //       <path d="M50 20 L40 35 L30 40 L15 30" stroke="#6A1B9A" strokeWidth="1.5" fill="none"/>
    //       <path d="M15 30 L25 40 L30 40" stroke="#00695C" strokeWidth="1.5" fill="none"/>
    //       <path d="M30 15 L20 25 L15 30" stroke="#FF9800" strokeWidth="1.5" fill="none"/>
          
    //       <circle cx="30" cy="15" r="3" fill="#E91E63"/>
    //       <circle cx="40" cy="25" r="3" fill="#E91E63"/>
    //       <circle cx="50" cy="20" r="3" fill="#E91E63"/>
    //       <circle cx="60" cy="35" r="3" fill="#E91E63"/>
    //       <circle cx="40" cy="35" r="3" fill="#6A1B9A"/>
    //       <circle cx="30" cy="40" r="3" fill="#6A1B9A"/>
    //       <circle cx="15" cy="30" r="3" fill="#6A1B9A"/>
    //       <circle cx="25" cy="40" r="3" fill="#00695C"/>
    //       <circle cx="20" cy="25" r="3" fill="#FF9800"/>
          
    //       <text x="70" y="30" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="#2D3142">SORANOVA</text>
    //       <text x="70" y="45" fontFamily="Arial, sans-serif" fontSize="10" fill="#2366E3">TECHNOLOGIES</text>
    //     </svg>
    //   );

    return (
        <AppBar position="fixed" color="inherit" elevation={0}>
            <Container maxWidth="xl">
                <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
                             <img src={mode === 'dark' ? darkLogo : lightLogo} alt="Logo" style={{ height: '60px' }} />
                        </Link>
                    </Box>

                    {/* Desktop Navigation */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center' }}>
                        {navItems.map((item) => (
                            <Button
                                key={item.id}
                                component={Link}
                                to={item.path}
                                color="inherit"
                                startIcon={item.icon}
                                aria-label={item.label}
                                sx={{
                                    mx: 1,
                                    position: 'relative',
                                    fontWeight: location.pathname === item.path ? 700 : 500,
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        width: location.pathname === item.path ? '70%' : '0%',
                                        height: '3px',
                                        bottom: '0',
                                        left: '15%',
                                        backgroundColor: 'primary.main',
                                        transition: 'width 0.3s ease',
                                        borderRadius: '3px',
                                    },
                                    '&:hover::after': {
                                        width: '70%',
                                    },
                                }}
                            >
                                {item.label}
                            </Button>
                        ))}
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            onClick={toggleTheme}
                            color="inherit"
                            aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}
                        >
                            {mode === 'dark' ? <LightMode /> : <DarkMode />}
                        </IconButton>

                        <Button
                            variant="contained"
                            component={Link}
                            to="/contact"
                            sx={{ ml: 2, display: { xs: 'none', md: 'flex' } }}
                        >
                            Get Started
                        </Button>

                        {/* Mobile Menu Button */}
                        <IconButton
                            color="inherit"
                            aria-label="menu"
                            onClick={() => setMenuOpen(!menuOpen)}
                            sx={{ display: { xs: 'flex', md: 'none' }, ml: 2 }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>

            {/* Mobile Navigation Drawer */}
            <Box
                component="nav"
                sx={{
                    height: menuOpen ? 'calc(100vh - 64px)' : 0,
                    overflow: 'hidden',
                    transition: 'height 0.3s ease',
                    position: 'fixed',
                    top: '64px',
                    left: 0,
                    right: 0,
                    bgcolor: 'background.paper',
                    zIndex: 1000,
                    display: { xs: 'block', md: 'none' },
                    borderTop: mode === 'dark' ? '1px solid rgba(106, 27, 255, 0.1)' : '1px solid rgba(94, 0, 255, 0.05)',
                }}
            >
                <Container maxWidth="xl">
                    <List sx={{ py: 2 }}>
                        {navItems.map((item) => (
                            <ListItem
                                key={item.id}
                                button
                                component={Link}
                                to={item.path}
                                onClick={() => setMenuOpen(false)}
                                sx={{
                                    borderRadius: 1,
                                    mb: 0.5,
                                    bgcolor: location.pathname === item.path
                                        ? mode === 'dark'
                                            ? 'rgba(106, 27, 255, 0.1)'
                                            : 'rgba(94, 0, 255, 0.05)'
                                        : 'transparent',
                                }}
                            >
                                <ListItemIcon sx={{ color: location.pathname === item.path ? 'primary.main' : 'inherit' }}>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText
                                    primary={item.label}
                                    primaryTypographyProps={{
                                        fontWeight: location.pathname === item.path ? 600 : 500,
                                        color: location.pathname === item.path ? 'primary.main' : 'text.primary'
                                    }}
                                />
                                {location.pathname === item.path && <ChevronRight color="primary" />}
                            </ListItem>
                        ))}
                        <ListItem sx={{ mt: 2 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                component={Link}
                                to="/contact"
                                onClick={() => setMenuOpen(false)}
                            >
                                Get Started
                            </Button>
                        </ListItem>
                    </List>
                </Container>
            </Box>
        </AppBar>
    );
};

export default Header;